import ProductFilter from './scripts';
import './styles/productFilter.scss';

ProductFilter.init();
